// Conversões de data para os campos de "começar a vender em".
// O banco espera ISO; a tela usa um campo <input type="date"> (YYYY-MM-DD).

export function dataParaISO(data: string): string | null {
  if (!data) return null;
  const d = new Date(`${data}T00:00:00`);
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString();
}

export function isoParaDataLocal(iso: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const ano = d.getFullYear();
  const mes = String(d.getMonth() + 1).padStart(2, '0');
  const dia = String(d.getDate()).padStart(2, '0');
  return `${ano}-${mes}-${dia}`;
}

export function formatarDataVenda(iso: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

// Converte um ISO (UTC) para o formato de <input type="datetime-local"> (hora local).
export function isoParaDataHoraLocal(iso: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const ano = d.getFullYear();
  const mes = String(d.getMonth() + 1).padStart(2, '0');
  const dia = String(d.getDate()).padStart(2, '0');
  const hora = String(d.getHours()).padStart(2, '0');
  const min = String(d.getMinutes()).padStart(2, '0');
  return `${ano}-${mes}-${dia}T${hora}:${min}`;
}

// Converte o valor de um datetime-local (hora local) de volta para ISO (UTC).
export function dataHoraParaISO(valor: string): string | null {
  if (!valor) return null;
  const d = new Date(valor);
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString();
}

// Cor da barra de estoque conforme o semáforo do painel.
export function corSemaforo(
  semaforo: 'verde' | 'amarelo' | 'vermelho' | 'preto' | null | undefined,
): string {
  switch (semaforo) {
    case 'verde':
      return 'bg-success-500';
    case 'amarelo':
      return 'bg-warning-500';
    case 'vermelho':
      return 'bg-danger-500';
    case 'preto':
      return 'bg-secondary-700';
    default:
      return 'bg-secondary-300';
  }
}